<template>
  <div v-if="member">
    <div class="centered-column">
      <div class="container-header">
        <button class="back-btn" @click="goBack">
          <i class="atto atto-ldir-arrow-b" />
        </button>
        <h3>{{ member.name }}</h3>
      </div>
      <div class="white-card">
        <div class="white-card-header pr-40">
          <div class="title-wrap">
            <label class="title-label">{{ label.get("account") }}</label>
          </div>
          <button
            v-if="canEditMember"
            class="update-btn"
            @click="showMemberDetailsModal"
          >
            <i class="atto atto-edit-btn-sv" />
            {{ label.get("update_user_details") }}
          </button>
        </div>
        <div class="user-details">
          <div class="user-profile">
            <div class="profile-pic">
              <img
                :alt="member.name"
                v-if="member.avatar"
                :src="member.avatar"
                width="100"
                height="100"
              />
              <span v-if="!member.avatar" class="initials">
                {{ member.initials }}
              </span>
            </div>
            <div class="user-info">
              <div class="name info-field">
                <span class="mail">{{ member.email }}</span>
              </div>
              <hr class="separator-line" />
              <div class="mail info-field">
                <span class="joined-date">{{
                  label.get("joined_date", { date: member.created_at })
                }}</span>
              </div>
            </div>
          </div>
          <div class="role-and-department">
            <div class="wrapper">
              <span class="label-wrap">
                <i class="atto atto-rdir-arrow-b" />
                {{ label.get("member_role") }}
              </span>
              <select-dropdown-component
                :value="member.role_id"
                :options="roles"
                :disabled="!canChangeRole"
                @onOptionSelected="onRoleChanged"
              />
            </div>
            <div class="wrapper" v-if="departmentEnabled">
              <span class="label-wrap">
                <i class="atto atto-rdir-arrow-b" />
                {{ label.get("department") }}
              </span>
              <select-dropdown-component
                :value="department"
                :options="departments"
                :disabled="!canEditMember"
                @onOptionSelected="onDepartmentChanged"
              />
            </div>
            <!--            <div v-if="showCustomPassportLicenseNumber">
              <div class="wrapper">
              <span class="label-wrap">
                 <i class="atto atto-rdir-arrow-b"/>
                {{ label.get('license_nr') }}
              </span>
                <input
                        type="text"
                        :value="member.license_number"
                        readonly

                />
              </div>
              <div class="wrapper mb-0">
              <span class="label-wrap">
                 <i class="atto atto-rdir-arrow-b"/>
                {{ label.get('nie_pass') }}
              </span>
                <input
                        type="number"
                        :value="member.passport_number"
                        readonly
                />
              </div>
            </div>-->
          </div>
        </div>
      </div>

      <pay-rates-component v-if="canEditMember && member" :member="member" />

      <div v-if="canEditMember" class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{
              label.get("overtime_preferences")
            }}</label>
            <button
              class="update-btn reset"
              type="button"
              :disabled="disabledResetToCompanySettingsButton"
              @click="resetToCompanySettings"
            >
              <i class="atto atto-sync-web" />
              {{ label.get("reset_to_company_settings") }}
            </button>
          </div>
          <div class="action-buttons" v-if="saveChangesEnabled">
            <button class="update-btn cancel" type="button" @click="cancel">
              <i class="atto atto-close-btn" />
              {{ label.get("cancel") }}
            </button>
            <button
              class="update-btn save-changes"
              type="button"
              :disabled="disabledSubmitButton"
              @click="saveChanges"
            >
              <i class="atto atto-selected-tick" />
              {{ label.get("save_changes") }}
            </button>
          </div>
        </div>
        <div class="overtime-preferences">
          <div class="card-content">
            <div class="d-flex align-items-center justify-content-between">
              <div class="check-wrapper switch-wrapper">
                <b-form-checkbox v-model="weeklyOvertime">
                  {{ label.get("overtime_weekly_overtime") }}
                </b-form-checkbox>
                <p class="disclaimer">
                  {{ label.get("overtime_weekly_overtime_description") }}
                </p>
              </div>
              <div
                class="overtime-calculations"
                :class="{ disabled: !weeklyOvertime }"
              >
                <div class="wrapper calculate-after">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b"></i>
                    {{ label.get("calculate_after") }}
                  </p>
                  <div class="input-wrapper">
                    <time-picker-component
                      v-model="weeklyCalculateAfter"
                      class="weekly-hours"
                      :format24h="true"
                      :unlimited-hours="true"
                      :add-seconds="false"
                      :max-time="[168, 0, 0]"
                      :required="true"
                    />
                  </div>
                </div>
                <div class="wrapper ot-pay-rate">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b"></i>
                    {{ label.get("overtime_pay_rate") }}
                  </p>
                  <div class="input-wrapper">
                    <input type="number" v-model="weeklyPayRate" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="card-content">
            <div class="d-flex align-items-center justify-content-between">
              <div class="check-wrapper switch-wrapper">
                <b-form-checkbox v-model="dailyOvertime">
                  {{ label.get("overtime_daily_overtime") }}
                </b-form-checkbox>
                <p class="disclaimer">
                  {{ label.get("overtime_daily_overtime_description") }}
                </p>
              </div>
              <div
                class="overtime-calculations"
                :class="{ disabled: !dailyOvertime }"
              >
                <div class="wrapper calculate-after">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b" />
                    {{ label.get("calculate_after") }}
                  </p>
                  <div class="input-wrapper">
                    <time-picker-component
                      v-model="dailyCalculateAfter"
                      class="daily-hours"
                      :add-seconds="false"
                      :format24h="true"
                      :required="true"
                    />
                  </div>
                </div>
                <div class="wrapper ot-pay-rate">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b"></i>
                    {{ label.get("overtime_pay_rate") }}
                  </p>
                  <div class="input-wrapper">
                    <input type="number" v-model="dailyPayRate" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="card-content">
            <div class="d-flex align-items-center justify-content-between">
              <div class="check-wrapper switch-wrapper">
                <b-form-checkbox v-model="dailyDoubleOvertime">
                  {{ label.get("overtime_daily_double_overtime") }}
                </b-form-checkbox>
                <p class="disclaimer">
                  {{ label.get("overtime_daily_double_overtime_description") }}
                </p>
              </div>
              <div
                class="overtime-calculations"
                :class="{ disabled: !dailyDoubleOvertime }"
              >
                <div class="wrapper calculate-after">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b" />
                    {{ label.get("calculate_after") }}
                  </p>
                  <div class="input-wrapper">
                    <time-picker-component
                      v-model="dailyDoubleCalculateAfter"
                      class="daily-double-hours"
                      :add-seconds="false"
                      :format24h="true"
                      :required="true"
                    />
                  </div>
                </div>
                <div class="wrapper ot-pay-rate">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b"></i>
                    {{ label.get("overtime_pay_rate") }}
                  </p>
                  <div class="input-wrapper">
                    <input type="number" v-model="dailyDoublePayRate" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-content seventh-day" v-if="!canEditMember">
            <div class="d-flex align-items-center justify-content-between">
              <div class="check-wrapper switch-wrapper">
                <b-form-checkbox
                    v-model="seventhDayOvertime"
                >
                  {{ label.get('7th_day_overtime') }}
                </b-form-checkbox>
                <p class="disclaimer">
                  {{ label.get('7th_day_overtime_description') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!canEditMember" class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('advanced_pay_settings') }}</label>
            <button
                class="update-btn reset"
                type="button"
                :disabled="disabledResetToCompanySettingsButton"
                @click="resetToCompanySettings"
            >
              <i class="atto atto-sync-web" />
              {{ label.get("reset_to_company_settings") }}
            </button>
          </div>
          <div class="action-buttons" v-if="saveAdvancedPayChangesEnabled">
            <button
                class="update-btn cancel"
                type="button"
                @click="cancelAdvancedPay"
            >
              <i class="atto atto-close-btn"/>
              {{ label.get('cancel') }}
            </button>
            <button
                class="update-btn save-changes"
                type="button"
                :disabled="disabledAdvancedSubmitButton"
                @click="saveAdvancedPayChanges"
            >
              <i class="atto atto-selected-tick"/>
              {{ label.get('save_changes') }}
            </button>
          </div>
        </div>
        <div class="overtime-preferences advanced-pay-settings">
          <div class="card-content">
            <div class="d-flex align-items-center justify-content-between">
              <div class="check-wrapper switch-wrapper">
                <b-form-checkbox
                    v-model="saturdaysOvertime"
                >
                  {{ label.get('saturdays') }}
                </b-form-checkbox>
                <p class="disclaimer">
                  {{ label.get('saturdays_overtime_description') }}
                </p>
              </div>
              <div class="overtime-calculations" :class="{'disabled': !saturdaysOvertime}">
                <div class="wrapper ot-pay-rate">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b"></i>
                    {{ label.get('pay_rate') }}
                  </p>
                  <div class="input-wrapper">
                    <input type="number"
                           v-model="saturdaysPayRate"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="card-content">
            <div class="d-flex align-items-center justify-content-between">
              <div class="check-wrapper switch-wrapper">
                <b-form-checkbox
                    v-model="sundaysOvertime"
                >
                  {{ label.get('sundays') }}
                </b-form-checkbox>
                <p class="disclaimer">
                  {{ label.get('sundays_overtime_description') }}
                </p>
              </div>
              <div class="overtime-calculations" :class="{'disabled': !sundaysOvertime}">
                <div class="wrapper ot-pay-rate">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b"></i>
                    {{ label.get('pay_rate') }}
                  </p>
                  <div class="input-wrapper">
                    <input type="number"
                           v-model="sundaysPayRate"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="card-content">
            <div class="d-flex align-items-center justify-content-between">
              <div class="check-wrapper switch-wrapper">
                <b-form-checkbox
                    v-model="publicHolidays"
                >
                  {{ label.get('public_holidays') }}
                </b-form-checkbox>
                <p class="disclaimer public-holidays">
                  {{ label.get('public_holidays_description') }}
                  <button @click="managePublicHolidays">
                    <i class="atto atto-rdir-arrow-b" />
                    <span>{{ label.get('manage_public_holidays') }}</span>
                  </button>
                </p>
              </div>
              <div class="overtime-calculations" :class="{'disabled': !publicHolidays}">
                <div class="wrapper ot-pay-rate">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b"></i>
                    {{ label.get('pay_rate') }}
                  </p>
                  <div class="input-wrapper">
                    <input type="number"
                           v-model="publicHolidaysPayRate"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="card-content">
            <div class="d-flex align-items-center justify-content-between">
              <div class="check-wrapper switch-wrapper">
                <b-form-checkbox
                    v-model="nightShiftsOvertime"
                >
                  {{ label.get('night_shifts') }}
                </b-form-checkbox>
                <p class="disclaimer">
                  {{ label.get('night_shifts_description') }}
                </p>
              </div>
              <div class="overtime-calculations calculate-between" :class="{'disabled': !nightShiftsOvertime}">
                <div class="wrapper calculate-after">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b"></i>
                    {{ label.get('calculate_between') }}
                  </p>
                  <div class="input-wrap">
                    <time-picker-component
                        v-model="nightShiftCalculateFrom"
                        class="weekly-hours"
                        :required="true"
                    />
                    <i class="atto atto-rdir-arrow-b"></i>
                    <time-picker-component
                        v-model="nightShiftCalculateTill"
                        :required="true"
                    />
                  </div>
                </div>
                <div class="wrapper ot-pay-rate">
                  <p class="label-wrap">
                    <i class="atto atto-rdir-arrow-b"></i>
                    {{ label.get('pay_rate') }}
                  </p>
                  <div class="input-wrapper">
                    <input type="number"
                           v-model="nightShiftsPayRate"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="canEditMember" class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{
              label.get("location_tracking_preferences")
            }}</label>
          </div>
        </div>
        <div class="card-content">
          <div class="check-wrapper switch-wrapper">
            <b-form-checkbox
              v-model="member.user_settings.location_tracking_enabled"
              @change="toggleUserLocationTracking(member)"
            >
              {{ label.get("require_location_tracking") }}
            </b-form-checkbox>
            <p class="disclaimer">
              {{ label.get("require_location_tracking_description") }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="canDeleteMember" class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get("delete_account") }}</label>
          </div>
        </div>
        <div class="card-content remove-member">
          <div class="d-flex align-items-center">
            <i class="atto atto-delete" />
            <p class="disclaimer">
              {{ label.get("delete_member_from_your_account_description") }}
            </p>
          </div>
          <button
            class="atto-btn deactivate md-btn"
            @click="deleteMember(member)"
          >
            {{ label.get("remove_member") }}
          </button>
        </div>
      </div>
    </div>
    <member-details-component
      :id="member.id"
      :name="member.name"
      :passport-number="member.passport_number"
      :license-number="member.license_number"
      v-if="showMemberDetails"
    />
    <delete-member-component v-if="deleteItem" :id="itemId" :type="itemType" />
    <public-holidays-component v-if="managePublicHolidaysModal"/>
  </div>
</template>

<script>
import MemberService from "../services/MemberService";
import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";
import MemberDetailsComponent from "./MemberDetailsComponent";
import LocationTrackingServices from "../../location-tracking/services/LocationTrackingService";
import TimePickerComponent from "../../../timesheets/shared/components/TimePickerComponent";
import DeleteMemberComponent from "./DeleteMemberComponent";
import CreatePayRateComponent from "./member-pay-rate/CreatePayRateComponent";
import DeletePayRateComponent from "./member-pay-rate/DeletePayRateComponent";
import EditPayRateComponent from "./member-pay-rate/EditPayRateComponent";
import PayRatesComponent from "./member-pay-rate/PayRatesComponent";
import PublicHolidaysComponent from "../../workweek-overtime/components/PublicHolidaysComponent";

export default {
  name: "MemberProfileComponent",
  components: {
    PublicHolidaysComponent,
    PayRatesComponent,
    EditPayRateComponent,
    DeletePayRateComponent,
    CreatePayRateComponent,
    DeleteMemberComponent,
    TimePickerComponent,
    MemberDetailsComponent,
    SelectDropdownComponent,
  },
  data() {
    return {
      member: null,
      initials: this.$route.params.uid.initials,
      roles: [
        {
          value: 1,
          label: this.label.get("admin"),
        },
        {
          value: 2,
          label: this.label.get("manager"),
        },
        {
          value: 3,
          label: this.label.get("employee"),
        },
      ],
      ownerId: this.$store.state.company.user_id,
      departmentEnabled: this.$store.state.companySettings.enable_departments,
      departments: this.getDepartmentsList(),
      showMemberDetails: false,
      deleteItem: false,
      itemId: null,
      itemType: null,
      showCustomPassportLicenseNumber: false, //this.$store.state.showCustomPassportLicenseNumber,
      weeklyOvertime: null,
      weeklyCalculateAfter: null,
      weeklyPayRate: null,
      dailyOvertime: null,
      dailyCalculateAfter: null,
      dailyPayRate: null,
      dailyDoubleOvertime: null,
      dailyDoubleCalculateAfter: null,
      dailyDoublePayRate: null,
      disabledSubmitButton: false,
      disabledResetToCompanySettingsButton: false,
      seventhDayOvertime: false,
      saturdaysOvertime: false,
      saturdaysPayRate: null,
      sundaysOvertime: false,
      sundaysPayRate: null,
      publicHolidays: false,
      publicHolidaysPayRate: null,
      nightShiftsOvertime: false,
      nightShiftCalculateFrom: null,
      nightShiftCalculateTill: null,
      nightShiftsPayRate: null,
      disabledAdvancedSubmitButton: false,
      managePublicHolidaysModal: false
    };
  },
  created() {
    this.getMember();
  },
  mounted() {
    this.$root.$on("hideDeleteMember", this.hideDeleteMember);
    this.$root.$on("pushNewDepartment", this.pushDepartments);
    this.$root.$on("hideMemberDetailsModal", this.hideMemberDetailsModal);
    this.$root.$on("onPublicHolidaysClose", this.onPublicHolidaysClose)
  },
  beforeDestroy() {
    this.$root.$off("hideDeleteMember");
    this.$root.$off("hideMemberDetailsModal");
    this.$root.$off("pushNewDepartment");
    this.$root.$off("onPublicHolidaysClose")
  },
  computed: {
    department() {
      if (this.member) {
        return this.member.department_id ? this.member.department_id : -1;
      }
      return -1;
    },
    saveChangesEnabled() {
      return (
        this.weeklyOvertime !== this.member.user_settings.weekly_overtime ||
        this.weeklyCalculateAfter !== this.member.user_settings.weekly_calculate_after ||
        this.weeklyPayRate !== this.member.user_settings.weekly_pay_rate ||
        this.dailyOvertime !== this.member.user_settings.daily_overtime ||
        this.dailyCalculateAfter !== this.member.user_settings.daily_calculate_after ||
        this.dailyPayRate !== this.member.user_settings.daily_pay_rate ||
        this.dailyDoubleOvertime !== this.member.user_settings.daily_double_overtime ||
        this.dailyDoubleCalculateAfter !== this.member.user_settings.daily_double_calculate_after ||
        this.dailyDoublePayRate !== this.member.user_settings.daily_double_pay_rate ||
        this.seventhDayOvertime !== this.member.user_settings.seventh_day_overtime
      );
    },
    saveAdvancedPayChangesEnabled() {
      return (
          this.saturdaysOvertime !== this.member.user_settings.saturdays ||
          this.saturdaysPayRate !== this.member.user_settings.saturdays_pay_rate ||
          this.sundaysOvertime !== this.member.user_settings.sundays ||
          this.sundaysPayRate !== this.member.user_settings.sundays_pay_rate ||
          this.publicHolidays !== this.member.user_settings.public_holidays ||
          this.publicHolidaysPayRate !== this.member.user_settings.public_holidays_pay_rate ||
          this.nightShiftsOvertime !== this.member.user_settings.night_shifts ||
          this.nightShiftCalculateFrom !== this.member.user_settings.night_shift_calculate_from ||
          this.nightShiftCalculateTill !== this.member.user_settings.night_shift_calculate_till ||
          this.nightShiftsPayRate !== this.member.user_settings.night_shift_pay_rate
      );
    },
    canChangeRole() {
      if (this.$store.state.user.id !== this.member.id) {
        if (this.$store.state.user.id === this.$store.state.company.user_id) {
          return true;
        } else if (
          this.$store.state.user.role_id < this.member.role_id &&
          this.$store.state.user.role_id === 1
        ) {
          return true;
        }
      }
      return false;
    },
    canEditMember() {
      if (this.$store.state.user.id === this.ownerId) {
        return true;
      }
      return (
        this.$store.state.user.role_id < this.member.role_id &&
        this.$store.state.user.role_id === 1
      );
    },
    canDeleteMember() {
      if (
        this.$store.state.user.id === this.ownerId &&
        this.member.id !== this.$store.state.user.id
      ) {
        return true;
      }
      if (
        this.member.id === this.ownerId ||
        this.member.id === this.$store.state.user.id
      ) {
        return false;
      }
      return (
        this.$store.state.user.role_id < this.member.role_id &&
        this.$store.state.user.role_id === 1
      );
    },
  },
  methods: {
    getDepartmentsList() {
      let departments = this.$store.state.companyDepartments.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
      departments.unshift({
        value: -1,
        label: this.label.get("no_department"),
      });

      return departments;
    },
    goBack() {
      this.$router.go(-1);
    },
    getMember() {
      const memberUID = this.$route.params.uid;
      this.$store.commit("showLoading");
      MemberService.getMemberWithSettings(memberUID)
        .then((result) => {
          this.member = result;
          this.weeklyOvertime = this.member.user_settings.weekly_overtime;
          this.weeklyCalculateAfter = this.member.user_settings.weekly_calculate_after;
          this.weeklyPayRate = this.member.user_settings.weekly_pay_rate;
          this.dailyOvertime = this.member.user_settings.daily_overtime;
          this.dailyCalculateAfter = this.member.user_settings.daily_calculate_after;
          this.dailyPayRate = this.member.user_settings.daily_pay_rate;
          this.dailyDoubleOvertime = this.member.user_settings.daily_double_overtime;
          this.dailyDoublePayRate = this.member.user_settings.daily_double_pay_rate;
          this.dailyDoubleCalculateAfter = this.member.user_settings.daily_double_calculate_after;
          this.seventhDayOvertime = this.member.user_settings.seventh_day_overtime;
          this.saturdaysOvertime = this.member.user_settings.saturdays;
          this.saturdaysPayRate = this.member.user_settings.saturdays_pay_rate;
          this.sundaysOvertime = this.member.user_settings.sundays;
          this.sundaysPayRate = this.member.user_settings.sundays_pay_rate;
          this.publicHolidays = this.member.user_settings.public_holidays;
          this.publicHolidaysPayRate = this.member.user_settings.public_holidays_pay_rate;
          this.nightShiftsOvertime = this.member.user_settings.night_shifts;
          this.nightShiftCalculateFrom = this.member.user_settings.night_shift_calculate_from;
          this.nightShiftCalculateTill = this.member.user_settings.night_shift_calculate_till;
          this.nightShiftsPayRate = this.member.user_settings.night_shift_pay_rate;

          if (result.user_settings.pay_rate_enabled) {
            this.getPayRates();
          }
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
        });
    },
    onRoleChanged(option) {
      this.member.role_id = option.value;
      const params = {
        user_id: this.member.id,
        role_id: option.value,
      };

      MemberService.changeMemberRole(params)
        .then((response) => {
          this.$awn.success(response.data.message);
        })
        .catch((error) => {});
    },
    onDepartmentChanged(option) {
      if (this.member.department_id !== option.value) {
        if (option.value > 0) {
          MemberService.addMemberToDepartment({
            user_id: this.member.id,
            department_id: option.value,
          })
            .then((response) => {
              this.member.department_id = option.value;
              this.$awn.success(response.data.message);
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (option.value === -1) {
          MemberService.deleteMemberFromDepartment({
            user_id: this.member.id,
          })
            .then((response) => {
              this.member.department_id = null;
              this.$awn.success(response.data.message);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
    showMemberDetailsModal() {
      this.showMemberDetails = true;
    },
    hideMemberDetailsModal(data) {
      if (data !== undefined && data !== null) {
        this.member.name = data.name;
        if (this.showCustomPassportLicenseNumber) {
          this.member.license_number = data.license_number;
          this.member.passport_number = data.passport_number;
        }

        this.$store.state.members.forEach((item) => {
          if (item.id === this.member.id) {
            item.name = data.name;

            if (this.showCustomPassportLicenseNumber) {
              item.license_number = data.license_number;
              item.passport_number = data.passport_number;
            }
          }
        });
      }
      this.showMemberDetails = false;
    },
    toggleUserLocationTracking(member) {
      const _this = this;
      if (_this.debounce) {
        clearTimeout(_this.debounce);
      }
      let data = {
        user_id: member.id,
        location_tracking_enabled: !member.user_settings
          .location_tracking_enabled,
      };
      _this.debounce = setTimeout(() => {
        LocationTrackingServices.updateMemberLocationTracking(data)
          .then((result) => {
            this.$awn.success(result.data.message);
            /*  this.$store.state.members = this.memberTracked;*/
          })
          .catch(() => {});
      }, 300);
    },
    deleteMember(member) {
      this.itemType = "member";
      this.itemId = member.id;
      this.deleteItem = true;
    },
    hideDeleteMember(data) {
      if (data) {
        this.$router.push({ path: "/settings/manage-team" });
      }

      this.deleteItem = false;
      this.itemId = null;
      this.itemType = null;
    },
    managePublicHolidays: function () {
      this.managePublicHolidaysModal = true;
    },
    saveChanges() {
      this.$store.commit("showLoading");
      this.disabledSubmitButton = true;

      this.resetEmptyOvertimeValuesToDefault();

      this.member.user_settings.weekly_overtime = this.weeklyOvertime;
      this.member.user_settings.weekly_calculate_after = this.weeklyCalculateAfter;
      this.member.user_settings.weekly_pay_rate = this.weeklyPayRate;
      this.member.user_settings.daily_overtime = this.dailyOvertime;
      this.member.user_settings.daily_calculate_after = this.dailyCalculateAfter;
      this.member.user_settings.daily_pay_rate = this.dailyPayRate;
      this.member.user_settings.daily_double_overtime = this.dailyDoubleOvertime;
      this.member.user_settings.daily_double_calculate_after = this.dailyDoubleCalculateAfter;
      this.member.user_settings.daily_double_pay_rate = this.dailyDoublePayRate;
      this.member.user_settings.seventh_day_overtime = this.seventhDayOvertime;

      MemberService.updateMemberSettings(this.member.user_settings)
        .then((response) => {
          const storeMember = this.$store.state.members.find(
            (x) => x.id === this.member.id
          );
          if (storeMember !== null) {
            const idx = this.$store.state.members.indexOf(storeMember);
            this.$store.state.members[
              idx
            ].user_settings = this.member.user_settings;
          }
          this.$store.commit("hideLoading");
          this.$awn.success(response.data.message);
          this.disabledSubmitButton = false;
          this.disabledResetToCompanySettingsButton = false;
        })
        .catch(() => {
          this.$store.commit("hideLoading");
          this.disabledSubmitButton = false;
          this.disabledResetToCompanySettingsButton = false;
        });
    },
    cancel() {
      this.disabledSubmitButton = false;

      this.weeklyOvertime = this.member.user_settings.weekly_overtime;
      this.weeklyCalculateAfter = this.member.user_settings.weekly_calculate_after;
      this.weeklyPayRate = this.member.user_settings.weekly_pay_rate;

      this.dailyOvertime = this.member.user_settings.daily_overtime;
      this.dailyCalculateAfter = this.member.user_settings.daily_calculate_after;
      this.dailyPayRate = this.member.user_settings.daily_pay_rate;

      this.dailyDoubleOvertime = this.member.user_settings.daily_double_overtime;
      this.dailyDoubleCalculateAfter = this.member.user_settings.daily_double_calculate_after;
      this.dailyDoublePayRate = this.member.user_settings.daily_double_pay_rate;

      this.seventhDayOvertime = this.member.user_settings.seventh_day_overtime;
    },
    onPublicHolidaysClose(){
      this.managePublicHolidaysModal = false;
    },
    resetEmptyOvertimeValuesToDefault() {
      if (
        this.weeklyCalculateAfter === "" ||
        this.weeklyCalculateAfter === null ||
        this.weeklyCalculateAfter === undefined
      ) {
        this.weeklyCalculateAfter = this.member.user_settings.weekly_calculate_after;
      }
      if (
        this.weeklyPayRate === "" ||
        this.weeklyPayRate === null ||
        this.weeklyPayRate === undefined
      ) {
        this.weeklyPayRate = this.member.user_settings.weekly_pay_rate;
      }
      if (
        this.dailyCalculateAfter === "" ||
        this.dailyCalculateAfter === null ||
        this.dailyCalculateAfter === undefined
      ) {
        this.dailyCalculateAfter = this.member.user_settings.daily_calculate_after;
      }
      if (
        this.dailyPayRate === "" ||
        this.dailyPayRate === null ||
        this.dailyPayRate === undefined
      ) {
        this.dailyPayRate = this.member.user_settings.daily_pay_rate;
      }
      if (
        this.dailyDoubleCalculateAfter === "" ||
        this.dailyDoubleCalculateAfter === null ||
        this.dailyDoubleCalculateAfter === undefined
      ) {
        this.dailyDoubleCalculateAfter = this.member.user_settings.daily_double_calculate_after;
      }
      if (
        this.dailyDoublePayRate === "" ||
        this.dailyDoublePayRate === null ||
        this.dailyDoublePayRate === undefined
      ) {
        this.dailyDoublePayRate = this.member.user_settings.daily_double_pay_rate;
      }
      if (
          this.saturdaysPayRate === "" ||
          this.saturdaysPayRate === null ||
          this.saturdaysPayRate === undefined
      ) {
        this.saturdaysPayRate = this.member.user_settings.saturdays_pay_rate;
      }
      if (
          this.sundaysPayRate === "" ||
          this.sundaysPayRate === null ||
          this.sundaysPayRate === undefined
      ) {
        this.sundaysPayRate = this.member.user_settings.sundays_pay_rate;
      }
      if (
          this.publicHolidaysPayRate === "" ||
          this.publicHolidaysPayRate === null ||
          this.publicHolidaysPayRate === undefined
      ) {
        this.publicHolidaysPayRate = this.member.user_settings.public_holidays_pay_rate;
      }
      if (
          this.nightShiftsPayRate === "" ||
          this.nightShiftsPayRate === null ||
          this.nightShiftsPayRate === undefined
      ) {
        this.nightShiftsPayRate = this.member.user_settings.night_shift_pay_rate;
      }
      if (
          this.nightShiftCalculateFrom === "" ||
          this.nightShiftCalculateFrom === null ||
          this.nightShiftCalculateFrom === "00:00:00" ||
          this.nightShiftCalculateFrom === undefined
      ) {
        this.nightShiftCalculateFrom = this.member.user_settings.night_shift_calculate_from;
      }
      if (
          this.nightShiftCalculateTill === "" ||
          this.nightShiftCalculateTill === null ||
          this.nightShiftCalculateTill === "00:00:00" ||
          this.nightShiftCalculateTill === undefined
      ) {
        this.nightShiftCalculateTill = this.member.user_settings.night_shift_calculate_till;
      }
    },
    saveAllChanges() {
      this.$store.commit("showLoading");
      this.disabledSubmitButton = true;

      this.resetEmptyOvertimeValuesToDefault();

      this.member.user_settings.weekly_overtime = this.weeklyOvertime;
      this.member.user_settings.weekly_calculate_after = this.weeklyCalculateAfter;
      this.member.user_settings.weekly_pay_rate = this.weeklyPayRate;
      this.member.user_settings.daily_overtime = this.dailyOvertime;
      this.member.user_settings.daily_calculate_after = this.dailyCalculateAfter;
      this.member.user_settings.daily_pay_rate = this.dailyPayRate;
      this.member.user_settings.daily_double_overtime = this.dailyDoubleOvertime;
      this.member.user_settings.daily_double_calculate_after = this.dailyDoubleCalculateAfter;
      this.member.user_settings.daily_double_pay_rate = this.dailyDoublePayRate;
      this.member.user_settings.seventh_day_overtime = this.seventhDayOvertime;
      this.member.user_settings.saturdays = this.saturdaysOvertime;
      this.member.user_settings.saturdays_pay_rate = this.saturdaysPayRate;
      this.member.user_settings.sundays = this.sundaysOvertime;
      this.member.user_settings.sundays_pay_rate = this.sundaysPayRate;
      this.member.user_settings.public_holidays = this.publicHolidays;
      this.member.user_settings.public_holidays_pay_rate = this.publicHolidaysPayRate;
      this.member.user_settings.night_shifts = this.nightShiftsOvertime;
      this.member.user_settings.night_shift_calculate_from = this.nightShiftCalculateFrom;
      this.member.user_settings.night_shift_calculate_till = this.nightShiftCalculateTill;
      this.member.user_settings.night_shift_pay_rate = this.nightShiftsPayRate;

      MemberService.updateMemberSettings(this.member.user_settings)
          .then((response) => {
            const storeMember = this.$store.state.members.find(
                (x) => x.id === this.member.id
            );
            if (storeMember !== null) {
              const idx = this.$store.state.members.indexOf(storeMember);
              this.$store.state.members[
                  idx
                  ].user_settings = this.member.user_settings;
            }
            this.$store.commit("hideLoading");
            this.$awn.success(response.data.message);
            this.disabledSubmitButton = false;
            this.disabledAdvancedSubmitButton = false;
            this.disabledResetToCompanySettingsButton = false;
          })
          .catch(() => {
            this.$store.commit("hideLoading");
            this.disabledSubmitButton = false;
            this.disabledAdvancedSubmitButton = false;
            this.disabledResetToCompanySettingsButton = false;
          });
    },
    resetToCompanySettings() {
      this.disabledResetToCompanySettingsButton = true;
      const companySettings = this.$store.state.companySettings;

      this.weeklyOvertime = companySettings.weekly_overtime;
      this.weeklyCalculateAfter = companySettings.weekly_calculate_after;
      this.weeklyPayRate = companySettings.weekly_pay_rate;

      this.dailyOvertime = companySettings.daily_overtime;
      this.dailyCalculateAfter = companySettings.daily_calculate_after;
      this.dailyPayRate = companySettings.daily_pay_rate;

      this.dailyDoubleOvertime = companySettings.daily_double_overtime;
      this.dailyDoubleCalculateAfter = companySettings.daily_double_calculate_after;
      this.dailyDoublePayRate = companySettings.daily_double_pay_rate;

      this.seventhDayOvertime = companySettings.seventh_day_overtime;

      this.saturdaysOvertime = companySettings.saturdays;
      this.saturdaysPayRate = companySettings.saturdays_pay_rate;

      this.sundaysOvertime = companySettings.sundays;
      this.sundaysPayRate = companySettings.sundays_pay_rate;

      this.publicHolidays = companySettings.public_holidays;
      this.publicHolidaysPayRate = companySettings.public_holidays_pay_rate;

      this.nightShiftsOvertime = companySettings.night_shifts;
      this.nightShiftCalculateFrom = companySettings.night_shift_calculate_from;
      this.nightShiftCalculateTill = companySettings.night_shift_calculate_till;
      this.nightShiftsPayRate = companySettings.night_shift_pay_rate;

      this.saveAllChanges();
    },
    saveAdvancedPayChanges() {
      this.$store.commit("showLoading");
      this.disabledAdvancedSubmitButton = true;

      this.resetEmptyOvertimeValuesToDefault();

      this.member.user_settings.saturdays = this.saturdaysOvertime;
      this.member.user_settings.saturdays_pay_rate = this.saturdaysPayRate;
      this.member.user_settings.sundays = this.sundaysOvertime;
      this.member.user_settings.sundays_pay_rate = this.sundaysPayRate;
      this.member.user_settings.public_holidays = this.publicHolidays;
      this.member.user_settings.public_holidays_pay_rate = this.publicHolidaysPayRate;
      this.member.user_settings.night_shifts = this.nightShiftsOvertime;
      this.member.user_settings.night_shift_calculate_from = this.nightShiftCalculateFrom;
      this.member.user_settings.night_shift_calculate_till = this.nightShiftCalculateTill;
      this.member.user_settings.night_shift_pay_rate = this.nightShiftsPayRate;

      MemberService.updateMemberSettings(this.member.user_settings)
          .then((response) => {
            const storeMember = this.$store.state.members.find(
                (x) => x.id === this.member.id
            );
            if (storeMember !== null) {
              const idx = this.$store.state.members.indexOf(storeMember);
              this.$store.state.members[
                  idx
                  ].user_settings = this.member.user_settings;
            }
            this.$store.commit("hideLoading");
            this.$awn.success(response.data.message);
            this.disabledAdvancedSubmitButton = false;
            this.disabledResetToCompanySettingsButton = false;
          })
          .catch(() => {
            this.$store.commit("hideLoading");
            this.disabledAdvancedSubmitButton = false;
            this.disabledResetToCompanySettingsButton = false;
          });
    },
    cancelAdvancedPay() {
      this.disabledAdvancedSubmitButton = false;

      this.saturdaysOvertime = this.member.user_settings.saturdays;
      this.saturdaysPayRate = this.member.user_settings.saturdays_pay_rate;
      this.sundaysOvertime = this.member.user_settings.sundays;
      this.sundaysPayRate = this.member.user_settings.sundays_pay_rate;
      this.publicHolidays = this.member.user_settings.public_holidays;
      this.publicHolidaysPayRate = this.member.user_settings.public_holidays_pay_rate;
      this.nightShiftsOvertime = this.member.user_settings.night_shifts;
      this.nightShiftCalculateFrom = this.member.user_settings.night_shift_calculate_from;
      this.nightShiftCalculateTill = this.member.user_settings.night_shift_calculate_till;
      this.nightShiftsPayRate = this.member.user_settings.night_shift_pay_rate;
    }

  },
};
</script>

<style lang="scss" scoped>
.container-wrap {
  .container-header {
    padding: 10px 8px;
    justify-content: flex-start;
  }
}

.card-content {
  padding: 40px 24px;
  .switch-wrapper {
    margin-left: 16px;
  }
  p {
    max-width: 670px;
    width: 100%;
    color: #666666;
    margin-top: 4px;
  }
  &.remove-member {
    padding: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .atto-delete {
      font-size: 19px;
      color: $atto-red;
    }
    p {
      padding-left: 21px;
      max-width: 567px;
      margin: 0;
    }
  }
}
.custom-control {
  &:hover {
    cursor: default;
  }
}
.deactivate {
  text-transform: uppercase;
}

.title-wrap {
  min-width: 420px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
}

.action-buttons {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  margin-right: 20px;

  .update-btn {
    width: auto;
    padding: 8px;
    font: $roboto-medium 13px/15px $roboto-regular;
    color: $atto-font-color;
    text-transform: capitalize;

    i {
      font-size: 8px;
    }
    &.cancel {
      margin-right: 12px;
      i {
        color: $atto-red;
      }
    }
  }
}

.list-container {
  .table-heading {
    height: 35px;
    background: $atto-grey;
    border-top: 1px solid $atto-light-grey;
    border-bottom: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 244px 12px 80px !important;
    .heading-label {
      text-transform: uppercase;
      font: $roboto-medium 0.625rem/0.6875rem $roboto-font;
      letter-spacing: 0.5px;
      color: #666666;
    }
  }
}
.atto-btn.deactivate:hover {
  background-color: #c24444;
}

 .advanced-pay-settings{
   .seventh-day{
     padding-top: 48px;
     padding-bottom: 60px;
   }
   p.disclaimer{
     margin-top: 4px;
     &.public-holidays{
       flex-flow: column;
       justify-content: flex-start;
       align-items: flex-start;

       button{
         display: flex;
         align-items: center;
         justify-content: flex-start;
         color: $atto-green;
         padding: 0;
         margin-top: 16px;
         i{
           width: 24px;
           height: 24px;
           text-decoration: none;
           font-size: 10px;
           display: flex;
           align-items: center;
           justify-content: center;
           margin-right: 4px;
         }
         span{
           @include fontSize(14px);
           @include lHeight(28px);
           font-family: $roboto-font;
           text-decoration: underline;
           text-transform: capitalize;
         }
       }
     }
   }
   .card-content{
     .calculate-between{
       align-items: flex-end;
       .wrapper{
         width: auto;

         &.ot-pay-rate{
           max-width: 260px;

           .input-wrapper{
             margin-left: 83px;
           }
         }
         &.calculate-after{
           .input-wrap{
             margin-left: 19px;
             display: flex;
             flex-flow: row;
             justify-content: space-between;
             align-items: center;
             i{
               width: 24px;
               height: 24px;
               @include fontSize(8px);
               display: inline-flex;
               justify-content: center;
               align-items: center;
               color: $atto-dark-grey;
             }
             input{
               width: 96px;
             }
           }
           .label-wrap{
             min-width: 137px;
           }
         }
       }
     }
   }
 }
</style>

<style lang="scss">
.back-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: transparent;
  color: $atto-dark-grey;
  margin-right: 16px;

  &:hover {
    background-color: #e3e3e3;
    color: $atto-font-color;
  }
}
.user-details {
  padding: 30px 40px;
  display: flex;
  flex-flow: row;
  justify-content: space-between;

  .user-profile {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .profile-pic {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 100px;
      max-width: 100px;
      height: 100px;
      margin-right: 40px;
      position: relative;

      > i {
        font-size: 119px;
        position: absolute;
        left: 0;
        top: 0;
      }

      .initials {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 1.5rem;
        line-height: 3rem;
        font-weight: 400;
        font-family: "Roboto", sans-serif;
        color: #999;
        background-color: #efefef;
        border-radius: 100%;
        width: 100%;
        height: 100%;
        text-transform: uppercase;
      }

      .edit-overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 100%;
        opacity: 0;

        .add {
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-top: 10px;
          -webkit-transition: ease all 0.15s;
          -moz-transition: ease all 0.15s;
          -ms-transition: ease all 0.15s;
          -o-transition: ease all 0.15s;
          transition: ease all 0.15s;
          transition-delay: 0.1s;
          cursor: pointer;

          i {
            width: 22px;
            height: 18px;
            background-image: url("~@assets/images/camera-icon.svg");
            -webkit-background-size: contain;
            background-size: contain;
            background-repeat: no-repeat;
            margin-bottom: 8px;
          }

          p {
            margin-bottom: 0;
            font-size: 0.75rem;
            line-height: 1.125rem;
            font-family: $roboto-font;
            font-weight: 500;
            color: #fff;
            text-align: center;
          }
        }

        .edit-pic {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 60px;

          .change {
            width: 24px;
            height: 24px;
            margin: 0;
            padding: 0;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            i {
              font-size: 16px;
              color: #fff;

              &:before {
                color: #fff;
              }
            }
          }

          .delete {
            width: 24px;
            height: 24px;
            margin: 0;
            padding: 0;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            i {
              font-size: 16px;
              color: #fff;
            }
          }
        }
      }

      img {
        border-radius: 100%;
      }

      &:hover {
        .edit-overlay {
          opacity: 1;

          .add {
            padding-top: 0;
          }
        }
      }
    }

    .user-info {
      display: inline-flex;
      flex-direction: column;
      justify-content: flex-start;
      padding-top: 10px;
      flex-grow: 1;
      max-width: calc(100% - 172px);

      .info-field {
        display: flex;
        flex-direction: row;
        min-width: 240px;
        margin-bottom: 0;
        align-items: center;
        flex-wrap: wrap;
        position: relative;

        h4.name {
          font-size: 1.25rem;
          line-height: 1.5rem;
          font-family: $roboto-font;
          font-weight: 500;
          color: $atto-font-color;
          margin-bottom: 0;
          max-width: calc(100% - 36px);
        }

        .invite-info {
          max-width: 405px;
        }

        input {
          width: 320px;
          margin-left: -12px;
          border: 2px solid #efefef;
          padding: 0 10px;
          font-family: $roboto-font;
          line-height: 36px;
          color: $atto-font-color;

          &.name-input {
            font-size: 1.5rem;
            line-height: 36px;
            font-weight: 500;
          }

          &.email-input {
            font-size: 1rem;
            font-weight: 400;
          }

          &:focus {
            border-color: #00b9cb;
          }
        }

        span {
          &.mail {
            display: inline-flex;
            color: $atto-font-color;
            font: $roboto-medium 1rem/1.75rem $roboto-font;
          }
          &.joined-date {
            font: $roboto-regular 0.9375rem/1.75rem $roboto-font;
          }
        }

        .change-alert {
          flex-grow: 2;
          width: 100%;
          display: inline-flex;
          font-size: 0.875rem;
          line-height: 1.25rem;
          font-family: $roboto-font;
          font-weight: 400;
          color: #e05656;
          max-width: 540px;
          margin-top: 6px;
        }

        &:last-child {
          margin-bottom: 0;
        }

        .error-wrapper {
          margin-right: 8px;
          margin-top: 0;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          top: 40px;

          .error-message {
            margin-top: 0;
          }

          .error-message:first-child {
            margin-top: 6px;
          }
        }
      }

      .error {
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        color: #e05656;
        top: calc(100% + 2rem);
        left: 0;
        margin-left: 0;
      }
      .separator-line {
        width: 40px;
        height: 2px;
        background-color: #efefef;
        margin: 11px 0;
        border: 0;
      }
    }

    button.edit {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      margin-left: 12px;
      width: 24px;
      height: 24px;

      i {
        display: inline-flex;
        width: 24px;
        height: 24px;
        justify-content: center;
        align-items: center;

        &:before {
          font-size: 18px;
          color: $atto-dark-grey;
          @include base-transition(ease color 0.2s);
        }
      }

      &:hover {
        cursor: pointer;

        i {
          &:before {
            color: $atto-font-color;
          }
        }
      }
    }

    button.change {
      width: 100px;
      margin-left: 16px;
      font-size: 1rem;
      font-family: $roboto-font;
      font-weight: 400;
      color: #fff;
      text-transform: uppercase;
      display: inline-flex;
      justify-content: center;
    }

    .changed-email {
      flex-grow: 2;
      width: 100%;
      padding-left: 152px;

      .info-field {
        margin-left: -12px;
        margin-bottom: 8px;

        input {
          width: 320px;
          border: 2px solid #efefef;
          padding: 0 10px;
          font-family: $roboto-font;
          line-height: 36px;
          color: $atto-font-color;

          &:focus {
            border-color: #00b9cb;
          }
        }
      }

      .error-message {
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        color: #e05656;
        max-width: 540px;
        margin: 0 0 24px;
      }

      span.label {
        color: #999999;
        font-family: "Roboto", sans-serif;
        font-size: 0.75rem;
        font-weight: 500;
        line-height: 1.5rem;
        margin-bottom: 4px;
      }

      p.error {
        margin: 0 0 24px;
        max-width: 540px;
        font-weight: 400;
        font-size: 0.875rem;
        line-height: 1.25rem;
      }

      .change-mail-wrap {
        display: flex;
        flex-direction: row;
        align-items: center;

        span {
          position: relative;
          width: 320px;
          border: 2px solid #efefef;
          padding: 0 10px;
          font-family: $roboto-font;
          line-height: 36px;
          color: $atto-font-color;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        i {
          font-size: 14px;
          width: 24px;
          height: 24px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }

      .email-change-footer {
        display: flex;

        button {
          display: inline-flex;
          justify-content: center;
          width: 280px;
          max-width: 100%;
          margin-right: 16px;
          text-transform: uppercase;
          font-weight: 500;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    &.emailInput-open {
      padding-bottom: 86px;
    }
  }
  .role-and-department {
    display: flex;
    flex-flow: column;
    min-width: 387px;

    .wrapper {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      height: 40px;
      align-items: center;
      margin-bottom: 20px;

      .label-wrap {
        font: $roboto-regular 0.875rem/1.75rem $roboto-font;
        color: $atto-font-color;

        i {
          font-size: 0.6875rem;
          margin-right: 7px;
        }
      }
      .atto-select {
        min-width: 270px;
      }
      input {
        min-width: 270px;
        height: 40px;
        padding: 8px 6px 8px 10px;
        border: 2px solid $atto-light-grey;
        font: $roboto-medium 0.875rem/1.25rem $roboto-font;
      }
    }
  }
  .invite-buttons {
    padding: 0 200px 60px 180px;

    button {
      text-transform: uppercase !important;

      &.atto-btn.submit {
        text-transform: uppercase !important;
      }
    }
  }
}
.atto-select .select-heading span.selected {
  font: $roboto-medium 0.875rem/1.25rem $roboto-font;
}
.switch-wrapper.check-wrapper {
  .custom-checkbox {
    cursor: default;
    .custom-control-label {
      text-transform: capitalize;
      cursor: default;
      &::before {
        width: 40px;
        height: 24px;
        top: 2px;
        left: -37px;
        border-radius: 12px;
        background: #e3e3e3;
        border: 2px solid #e3e3e3 !important;
      }
      &::after {
        content: "";
        width: 21px;
        height: 21px;
        background-color: #fff;
        border-radius: 50% !important;
        font-size: 20px;
        top: 3px;
        left: -37px;
      }
    }
  }
}
.switch-wrapper.check-wrapper .custom-checkbox .custom-control-label {
  font-size: 0.9375rem;
  line-height: 1.75rem;
}
.switch-wrapper
  .custom-control-input:not(:disabled):active
  ~ .switch-wrapper
  .custom-control-label::before {
  background-color: $atto-green !important;
  border-color: $atto-green !important;
  width: 40px;
  height: 24px;
  border-radius: 15.5px;
}
.check-wrapper.switch-wrapper .custom-checkbox .custom-control-label::after {
  content: "";
  width: 21px;
  height: 21px;
  background-color: #fff;
  border-radius: 50% !important;
  font-size: 20px;
  top: 3.7px;
  left: -35px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 0 rgba(0, 0, 0, 0.1),
    0 1px 1px 0 rgba(0, 0, 0, 0.05);
}
.check-wrapper.switch-wrapper
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::before {
  background: $atto-green;
  border: 2px solid $atto-green !important;
  width: 40px;
  height: 24px;
}
.check-wrapper.switch-wrapper
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::after {
  content: "";
  width: 21px;
  height: 21px;
  background: #fff;
  border-radius: 50%;
  top: 3.49px;
  left: -20px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 0 rgba(0, 0, 0, 0.1),
    0 1px 1px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.reset {
  i.atto-sync-web:before {
    color: #000000;
  }
}

.overtime-preferences {
  .card-content {
    padding: 40px 40px 40px 24px;

    .overtime-calculations {
      display: flex;
      flex-flow: column;

      .wrapper {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        align-items: center;
        width: 260px;

        .label-wrap {
          width: auto;
          max-width: none;
          margin: 0;
          font: $roboto-regular 0.875rem/1.25rem $roboto-font;
          color: $atto-font-color;
        }
        .input-wrapper {
          width: 96px;
          min-width: 96px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          &:after {
            width: 32px;
            min-width: 32px;
            height: 40px;
            border: 2px solid $atto-light-grey;
            background-color: $atto-grey;
            display: flex;
            align-items: center;
            justify-content: center;
            font: $roboto-medium 0.875rem/1.25rem $roboto-font;
          }
          input {
            width: 100%;
            max-width: 64px;
            border: 2px solid $atto-light-grey;
            border-right: none;
            height: 40px;
            font: $roboto-medium 0.875rem/1.25rem $roboto-font;

            /* &::selection{
                background-color: rgba(10,212,210,0.25);
              }*/
          }
          input[type="number"] {
            text-indent: 12px;
          }
        }
        &.ot-pay-rate {
          .input-wrapper {
            &:after {
              content: "x";
            }
          }
        }
        &.calculate-after {
          margin-bottom: 16px;
          .input-wrapper {
            &:after {
              content: "h";
            }
          }
        }
      }
      &.disabled {
        .wrapper {
          .label-wrap {
            color: $atto-not-active;

            i {
              color: $atto-dark-grey;
            }
          }
          .input-wrapper,
          .input-wrap{
            input {
              background-color: $atto-grey;
              color: $atto-dark-grey;
            }
            &:after {
              color: $atto-dark-grey;
            }
          }
        }
      }
    }
    p {
      max-width: 400px;
      color: #666666;
    }
  }
  hr {
    margin-right: 40px;
    margin-left: 24px;
  }
}
.overtime-calculations {
  .label-wrap {
    font: $roboto-regular 0.875rem/1.75rem $roboto-font;
    color: $atto-font-color;

    i {
      font-size: 0.6875rem;
      margin-right: 7px;
    }
  }
}
</style>
